<template>
  <common-input
      v-model="term"
      class="form__input"
      label="Zoek op richtlijn of project"
      bg-color="neutral-5"
      dense
      ref="searchInput"
      @update:modelValue="doSearch(term)"
  >
    <template v-slot:prepend>
      <q-icon name="search" aria-hidden="true" />
    </template>

    <q-menu ref="resultMenu" fit no-focus>
      <q-list
          class="rounded-borders"
          bordered
          separator
          ref="innerMenu"
          @focusout="focusOut"
      >
        <q-item v-if="noResults">
          <q-item-section>
            <div class="row items-center q-col-gutter-x-md">
              <div class="col flex items-center">
                Geen resulten gevonden
              </div>
            </div>
          </q-item-section>
        </q-item>
        <q-item v-for="(item, index) in results" :key="index">
          <q-item-section avatar>
            <div class="row">
              <type-chip :label="item.type === 'rule' ? 'Richtlijn': 'Project'" />
            </div>
          </q-item-section>
          <q-item-section>
            <div class="row items-center q-col-gutter-x-md">
              <div class="col flex items-center">
                <a :href="item.link"
                   class="link link--dark"
                   @keydown.tab.native="preventTabOut(index, $event)"
                >
                  {{ item.name }}
                </a>
              </div>
            </div>
          </q-item-section>
        </q-item>
      </q-list>
    </q-menu>
  </common-input>
</template>

<script>
import { ref } from 'vue'

export default {
  data: () => ({
    term: '',
    results: [],
    noResults: false,
    searching: false,
  }),
  methods: {
    doSearch: _.debounce(async function (term) {
      this.noResults = false
      if (!term || this.term !== term) return
      const response = await axios.get(this.$route('api.search', term))
      this.results = response.data.data
      this.searching = false
      this.noResults = this.results.length === 0
      this.$refs.resultMenu.show()
    }, 300),
    preventTabOut (index, $event) {
      if ((index === 0 && $event.shiftKey) || (index === this.results.length - 1 && !$event.shiftKey)) {
        $event.preventDefault()
        return false
      }
    },
  },
}
</script>
